export const addToRecord: <T, R extends T>(record: Record<string, T>, id: string, newValue: R) => Record<string, T> = (
  state,
  id,
  newValue
) => ({
  ...state,
  [id]: newValue,
});
